import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/activities/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_ID = NAMESPACE + 'SET_LAST_LOADED_ID'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET = NAMESPACE + 'SET'

const defaultBoardState = {
  activities: [],
  activitiesById: {},
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false
}

const initialState = {}

const transformActvity = (activity) => {
  const _activity = {
    ...activity
  }

  if ((activity.data.action === 'EditCommentOnCard' ||
       activity.data.action === 'RemoveCommentFromCard') &&
       activity.data.originalTimestamp) {
    _activity.timestamp = activity.data.originalTimestamp
  }

  return _activity
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case SET_LOAD_STATUS:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded,
        }
      } : state
    case SET_LAST_LOADED_ID:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          lastLoadedId: action.payload.lastLoadedId
        }
      } : undefined
    case ADD: {
      if (!state[action.payload.boardId]) return state

      const activity = transformActvity(action.payload.activity)

      return {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          activities: addUniqueValueToArray({
            array: state[action.payload.boardId].activities,
            value: activity.id,
            index: activity.index
          }),
          activitiesById: {
            ...state[action.payload.boardId].activitiesById,
            [activity.id]: {
              ...activity
            }
          }
        }
      }
    }
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          activities: [ ...state[action.payload.boardId].activities ],
          activitiesById: { ...state[action.payload.boardId].activitiesById },
        }
      }

      action.payload.array.forEach(activity => {
        activity = transformActvity(activity)
        newState[action.payload.boardId].activities = addUniqueValueToArray({
          array: newState[action.payload.boardId].activities,
          value: activity.id,
          index: activity.index
        })
        newState[action.payload.boardId].activitiesById[activity.id] = {
          ...activity
        }
      })

      return newState
    }
    case REMOVE: {
      if (!state[action.payload.boardId] || !state[action.payload.boardId].activitiesById[action.payload.activityId]) return state

      const newState = {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          activities: [ ...state[action.payload.boardId].activities.filter(id => id !== action.payload.activityId) ],
          activitiesById: { ...state[action.payload.boardId].activitiesById }
        }
      }

      delete newState[action.payload.boardId].activitiesById[action.payload.activityId]

      return newState
    }
    case SET:
      return state[action.payload.boardId] && state[action.payload.boardId].activitiesById[action.payload.activity.id] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          activitiesById: {
            ...state[action.payload.boardId].activitiesById,
            [action.payload.activity.id]: {
              ...state[action.payload.boardId].activitiesById[action.payload.activity.id],
              ...action.payload.activity
            }
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ boardId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      boardId,
      isLoading,
      isLoaded,
    }
  }
}

export function setLastLoadedId ({ boardId, lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_ID,
    payload: {
      boardId,
      lastLoadedId,
    }
  }
}

export function add ({ boardId, activity }) {
  return {
    type: ADD,
    payload: {
      boardId,
      activity,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array,
    }
  }
}

export function remove ({ boardId, activityId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      activityId,
    }
  }
}

export function set ({ boardId, activity }) {
  return {
    type: SET,
    payload: {
      boardId,
      activity,
    }
  }
}
